const coins = {
  coinsAsic: {
    sha256: "sha256",
    scrypt: "scrypt",
    equihash: "eq",
    kadena: "kd",
    x11: "x11",
    eaglesong: "esg",
    handshake: "hk",
    kheavyhash: "hh",
    randomX: "rmx",
    sia: "sia",
    quark: "qk",
    qubit: "qb",
    lbry: "lbry",
    blake14r: "bk14",
    cryptonight: "cn",
    cryptonightSTC: "cst",
    lyra2rev2: "lre",
    keccak: "kec",
    groestl: "gro",
    cuckatoo32: "ct32",
    myrgroestl: "mg",
    skein: "sk",
    bcd: "bcd",
    lyra2z: "l2z",
    radiant: "s5r",
    zksnark: "zk",
  },

  coinsGPU: {
    ethash: "eth",
    ethash4g: "e4g",
    etchash: "eth",
    zhash: "zh",
    cnheavy: "cnh",
    cngpu: "cng",
    cortex: "cx",
    dynes: "ds",
    cuckoocycle: "cc",
    cuckarood29: "cr29",
    cuckatoo32: "ct32",
    beam: "eqb",
    blake3: "b3",
    neoscrypt: "ns",
    autolykos: "al",
    octopus: "ops",
    ironfish: "ir",
    zelhash: "zlh",
    kawpow: "kpw",
    progpow: "ppw",
    nexapow: "nx",
    firowpow: "fpw",
    verthash: "vh",
    zksnark: "zk",
    SHA3x: "s3x",
  },
};

export { coins };
